import useFetch, { UseFetchResult } from "../../../hooks/fetch/useFetch";
import { Setting } from "../../setting/models/Setting";
import { SettingDefinitionEdit } from "../models/SettingDefinitionEdit";

interface IUseEditSettingDefinition {
  id: string | number;
}

interface IUseEditSettingDefinitionReturn {
  fetch: UseFetchResult<Setting, SettingDefinitionEdit>;
}

export const useEditSettingDefinition = ({
  id,
}: IUseEditSettingDefinition): IUseEditSettingDefinitionReturn => {
  const fetch = useFetch<Setting, SettingDefinitionEdit>(
    `/api/setting-definitions/${id}`,
    {
      skipInitialFetch: true,
      method: "put",
      withToast: true,
    }
  );

  return {
    fetch,
  };
};
